module.exports = __webpack_public_path__ + "img/暂无赛事证书@2x.d6d402cd.png";